import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import './quasar'
import "./globleComponent";
import "./globalComponents";
import "./globalMixin";
import store from './store';
import routes from './routes';
import VueMoment from "vue-moment/dist/vue-moment";
import VueRouterTab from "vue-router-tab";
import './services/axios';
import { routeTracker } from './routeTracker';


Vue.config.productionTip = false;

Vue.use(VueRouterTab);
Vue.use(VueRouter);
Vue.use(VueMoment);


export const router = new VueRouter({
  mode: "history",
  routes,
});

routeTracker();


router.afterEach((to) => {
  const isEntryPoint = !!(to.meta && to.meta.isEntryPoint);
  sessionStorage.setItem('hasInAppHistory', isEntryPoint ? 'false' : 'true');
});


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
